export const singingPortraitsHomepageImages = [
  {
    src: '/images/forYou/image1.jpg',
    srcSet: `
              /images/forYou/image1.jpg 1x,
              /images/forYou/image1@2x.jpg 2x,
            `,
  },
  {
    src: '/images/forYou/image2.jpg',
    srcSet: `
              /images/forYou/image2.jpg 1x,
              /images/forYou/image2@2x.jpg 2x,
            `,
  },
  {
    src: '/images/forYou/image3.jpg',
    srcSet: `
              /images/forYou/image3.jpg 1x,
              /images/forYou/image3@2x.jpg 2x,
            `,
  },
  {
    src: '/images/forYou/image4.jpg',
    srcSet: `
              /images/forYou/image4.jpg 1x,
              /images/forYou/image4@2x.jpg 2x,
            `,
  },
  {
    src: '/images/forYou/image5.jpg',
    srcSet: `
              /images/forYou/image5.jpg 1x,
              /images/forYou/image5@2x.jpg 2x,
            `,
  },
]
